/** need to be updated with a handled DNS record */
// const base_url =
//   'https://j5cf2ek4r5.execute-api.eu-west-1.amazonaws.com/default';
const env = process.env.REACT_APP_ENV
const base_url = `https://api.${env}.baltee-tech.com`; 

const bearer_token = "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";

export async function stripeCheckoutAPI(data) {
    const url = base_url + `/stripe/checkout`;
  
    var myHeaders = new Headers();
  
    var raw = JSON.stringify(data);
  
    var requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders,
      body: raw,
    };
  
    const response = await fetch(url, requestOptions);

    if (response.status === 200 || response.status === 201) {
      const json = await response.json();
      return json;
    } else {
      return response.status;
    }
  }

  export async function stripeProductsAPI(token, id) {
    const url = "https://api.stripe.com/v1/products?limit=100";
  
    var myHeaders = new Headers();
    // "Content-Type": "application/x-www-form-urlencoded"
    myHeaders.append('Authorization', `Bearer ${bearer_token}`);
  
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders,
    };
  
    const response = await fetch(url, requestOptions);
  
    if (response.status === 200) {
      const json = await response.json();
      return json;
    } else {
      return response.status;
    }
  }

  export async function stripePriceAPI(id) {
    const url = `https://api.stripe.com/v1/prices/${id}`;
  
    var myHeaders = new Headers();
    // "Content-Type": "application/x-www-form-urlencoded"
    myHeaders.append('Authorization', `Bearer ${bearer_token}`);
  
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders,
    };
  
    const response = await fetch(url, requestOptions);
  
    if (response.status === 200) {
      const json = await response.json();
      return json;
    } else {
      return response.status;
    }
  }

  export async function stripeProductPricesAPI(id) {
    const url = `https://api.stripe.com/v1/prices?product=${id}`;
  
    var myHeaders = new Headers();
    // "Content-Type": "application/x-www-form-urlencoded"
    myHeaders.append('Authorization', `Bearer ${bearer_token}`);
  
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders,
    };
  
    const response = await fetch(url, requestOptions);
  
    if (response.status === 200) {
      const json = await response.json();
      return json;
    } else {
      return response.status;
    }
  }

  export async function stripeGetSuccessCheckoutAPI(id) {
    const url = base_url + `/stripe/session?session_id=${id}`;
  
    var myHeaders = new Headers();
  
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders,
    };
  
    const response = await fetch(url, requestOptions);
  
    if (response.status === 200) {
      const json = await response.json();
      return json;
    } else {
      return response.status;
    }
  }